// Hebrew translations
export const he: Record<string, string> = {
  // Main Menu
  'menu.dashboard': 'לוח בקרה',
  'menu.orderNew': 'רישום מוצר',
  'menu.deliveryList': 'רשימת משלוחים',
  'menu.delivery': 'משלוח',
  'menu.receipt': 'הדפסת קבלה/תווית',
  'menu.definitions': 'הגדרות',
  'menu.customers': 'לקוחות',
  'menu.products': 'הגדרות מוצרים',
  'menu.pricing': 'הגדרות מחירים',
  'menu.tailoring': 'פעולות תפירה',
  'menu.attributes': 'תכונות מוצרים',
  'menu.users': 'משתמשים',
  'menu.productOrdering': 'סידור מוצרים',
  'menu.discounts': 'הגדרות הנחות',
  'menu.settings': 'הגדרות',
  'menu.generalSettings': 'הגדרות כלליות',
  'menu.permissions': 'ניהול הרשאות',
  'menu.subscription': 'מנוי',
  'menu.invoices': 'ניהול חשבוניות',
  'menu.expenses': 'הזנת הוצאות',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': 'דוחות והנהלת חשבונות',
  'menu.systemAndCommunication': 'מערכת ותקשורת',
  'menu.reportsList': 'רשימת קבלות',
  'menu.accountStatement': 'דוח חשבון',
  'menu.tickets': 'בקשות תמיכה',
  'menu.support': 'תמיכה',
  'menu.profile': 'פרופיל',
  'menu.logout': 'התנתק',
  'menu.notifications': 'התראות SMS/WhatsApp',
  'menu.whatsappConnection': 'חיבור WhatsApp',
  'menu.smsConnection': 'חיבור SMS',
  
  // Dashboard
  'dashboard.title': 'לוח בקרה',
  'dashboard.todaySales': 'מכירות היום',
  'dashboard.totalOrders': 'סה"כ הזמנות',
  'dashboard.pendingDeliveries': 'משלוחים ממתינים',
  'dashboard.activeCustomers': 'לקוחות פעילים',
  'dashboard.recentOrders': 'הזמנות אחרונות',
  'dashboard.viewAll': 'צפה בהכל',
  'dashboard.quickActions': 'פעולות מהירות',
  'dashboard.newOrder': 'הזמנה חדשה',
  'dashboard.newCustomer': 'לקוח חדש',
  'dashboard.deliveries': 'משלוחים',
  'dashboard.reports': 'דוחות',
  'dashboard.today': 'היום',
  'dashboard.yesterday': 'אתמול',
  'dashboard.week': 'שבוע',
  'dashboard.month': 'חודש',
  'dashboard.quarter': 'רבעון',
  'dashboard.year': 'שנה',
  'dashboard.totalRevenue': 'סה"כ הכנסות',
  'dashboard.totalOrdersCard': 'סה"כ הזמנות',
  'dashboard.totalPieces': 'סה"כ פריטים',
  'dashboard.cancelled': 'בוטל',
  'dashboard.inProcess': 'בתהליך',
  'dashboard.inProcessDesc': 'הזמנות בתהליך',
  'dashboard.ready': 'מוכן',
  'dashboard.readyDesc': 'הזמנות מוכנות למשלוח',
  'dashboard.delivered': 'נמסר',
  'dashboard.deliveredDesc': 'הזמנות שהושלמו',
  'dashboard.announcements': 'הודעות',
  'dashboard.announcementAll': 'כללי',
  'dashboard.announcementPrivate': 'פרטי',
  
  // Order Entry
  'order.title': 'הזמנה חדשה',
  'order.customer': 'לקוח',
  'order.selectCustomer': 'בחר לקוח',
  'order.newCustomer': 'לקוח חדש',
  'order.products': 'מוצרים',
  'order.addProduct': 'הוסף מוצר',
  'order.selectProduct': 'בחר מוצר',
  'order.quantity': 'כמות',
  'order.price': 'מחיר',
  'order.total': 'סה"כ',
  'order.discount': 'הנחה',
  'order.subtotal': 'סכום ביניים',
  'order.tax': 'מע"מ',
  'order.grandTotal': 'סה"כ כללי',
  'order.payment': 'תשלום',
  'order.paymentMethod': 'אמצעי תשלום',
  'order.cash': 'מזומן',
  'order.card': 'כרטיס אשראי',
  'order.credit': 'אשראי',
  'order.amountPaid': 'סכום ששולם',
  'order.remainingBalance': 'יתרה',
  'order.deliveryDate': 'תאריך משלוח',
  'order.notes': 'הערות',
  'order.createOrder': 'צור הזמנה',
  'order.cancel': 'ביטול',
  
  // Users
  'users.title': 'משתמשים',
  'users.addNew': 'משתמש חדש',
  'users.name': 'שם',
  'users.email': 'דוא"ל',
  'users.role': 'תפקיד',
  'users.pin': 'PIN',
  'users.permissions': 'הרשאות',
  'users.allPermissions': 'כל ההרשאות',
  'users.permissionCount': '{count} הרשאות',
  'users.changePin': 'שנה PIN',
  'users.edit': 'ערוך',
  'users.delete': 'מחק',
  'users.newUser': 'משתמש חדש',
  'users.editUser': 'ערוך משתמש',
  'users.editingUser': 'עריכת {name}',
  'users.deleteUserTitle': 'מחק משתמש',
  'users.deletingUser': 'האם אתה בטוח שברצונך למחוק את {name}?',
  'users.pinCode': 'קוד PIN (4-6 ספרות)',
  'users.selectRole': 'בחר תפקיד',
  'users.patron': 'בעלים',
  'users.kasiyer': 'קופאי',
  'users.sofor': 'נהג',
  'users.changePinTitle': 'שנה קוד PIN',
  'users.newPin': 'קוד PIN חדש',
  'users.confirmPin': 'אשר קוד PIN',
  'users.pinMismatch': 'קודי PIN אינם תואמים',
  'users.pinRequired': 'נדרש קוד PIN',
  'users.pinLength': 'קוד PIN חייב להיות בן 4-6 ספרות',
  'users.changingPinFor': 'שינוי PIN עבור {name}',
  
  // Products
  'products.title': 'הגדרות מוצרים',
  'products.addNew': 'מוצר חדש',
  'products.category': 'קטגוריה',
  'products.name': 'שם מוצר',
  'products.price': 'מחיר',
  'products.color': 'צבע',
  'products.active': 'פעיל',
  'products.actions': 'פעולות',
  'products.search': 'חפש מוצר...',
  'products.noProducts': 'לא נמצאו מוצרים',
  'products.noCategoryProducts': 'אין מוצרים בקטגוריה זו',
  'products.emptyCart': 'העגלה ריקה',
  
  // Service Types
  'service.tailor': 'תפירה',
  'service.dryCleaning': 'ניקוי יבש',
  'service.washing': 'כביסה',
  'service.ironing': 'גיהוץ',
  'service.shoeShine': 'צחצוח נעליים',
  'service.carpet': 'שטיח',
  'service.tailoring': 'תיקוני תפירה',
  'service.carpetWashing': 'כביסת שטיחים',
  'service.selectService': 'בחר שירות',
  'service.addToCart': 'הוסף לעגלה',
  'service.total': 'סה"כ',
  
  // Common
  'common.yes': 'כן',
  'common.no': 'לא',
  'common.cancel': 'ביטול',
  'common.confirm': 'אישור',
  'common.delete': 'מחק',
  'common.edit': 'ערוך',
  'common.save': 'שמור',
  'common.search': 'חיפוש',
  'common.loading': 'טוען...',
  'common.noData': 'אין נתונים',
  'common.actions': 'פעולות',
  'common.status': 'סטטוס',
  'common.date': 'תאריך',
  'common.time': 'שעה',
  'common.total': 'סה"כ',
  'common.filter': 'סנן',
  'common.export': 'ייצא',
  'common.print': 'הדפס',
  'common.close': 'סגור',
  'common.back': 'חזור',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.submit': 'שלח',
  'common.reset': 'אפס',
  'common.create': 'צור',
  'common.creating': 'יוצר...',
  'common.later': 'מאוחר יותר',
  'common.clear': 'נקה',
  'common.copied': 'הועתק!',
  'common.copyError': 'ההעתקה נכשלה',
  'common.autoDetected': 'זוהה אוטומטית',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.pieces': 'pieces',
  
  // Login
  'login.title': 'Cleandy',
  'login.subtitle': 'מערכת ניהול ניקוי יבש',
  'login.tenantId': 'מזהה חברה',
  'login.tenantPlaceholder': 'מזהה-חברה (לדוגמה: acme-clean)',
  'login.tenantIdHelp': 'הזן את מזהה החברה הייחודי שלך',
  'login.continue': 'המשך →',
  'login.notMember': 'עדיין לא חבר?',
  'login.startTrial': 'התחל תקופת ניסיון חינם',
  'login.adminLogin': '🔒 כניסת מנהל',
  'login.enterPin': 'הזן את קוד ה-PIN שלך',
  'login.changeTenant': 'שנה חברה',
  'login.clear': 'נקה',
  'login.delete': 'מחק',
  'login.login': 'התחבר',
  'login.loggingIn': 'מתחבר...',
  'login.defaultPinOwner': 'PIN ברירת מחדל: <strong>1234</strong> (בעלים)',
  'login.defaultPinCashier': 'PIN ברירת מחדל: <strong>0000</strong> (קופאי)',
  'login.systemInitializing': 'מאתחל מערכת...',
  'login.pinMinLength': 'PIN חייב להכיל לפחות 4 ספרות',
  'login.invalidTenantId': 'הזן מזהה חברה תקין',
  'login.tenantNotFound': 'קוד חברה זה לא נמצא. בדוק או צור חשבון חדש.',
  'login.loginFailed': 'ההתחברות נכשלה',
  'login.welcome': '&X',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',

  // Signup translations
  'signup.title': 'התחל תקופת ניסיון חינם',
  'signup.subtitle': '15 יום חינם, ללא צורך בכרטיס אשראי',
  'signup.backToLogin': 'חזור לדף התחברות',
  'signup.companyCode': 'קוד חברה',
  'signup.companyCodePlaceholder': 'לדוגמה: cleanpro',
  'signup.companyCodeHelp': 'קוד זה ישמש להתחברות למערכת',
  'signup.companyCodeMinLength': 'קוד חברה חייב להכיל לפחות 3 תווים',
  'signup.companyName': 'שם חברה',
  'signup.companyNamePlaceholder': 'שם החברה שלך',
  'signup.companyNameRequired': 'שם חברה נדרש',
  'signup.fullName': 'שם מלא',
  'signup.fullNamePlaceholder': 'השם המלא שלך',
  'signup.fullNameRequired': 'שם מלא נדרש',
  'signup.phone': 'טלפון',
  'signup.phonePlaceholder': '+972 50-123-4567',
  'signup.validPhoneRequired': 'הזן מספר טלפון תקין',
  'signup.email': 'דוא"ל',
  'signup.emailPlaceholder': 'example@company.com',
  'signup.validEmailRequired': 'הזן כתובת דוא"ל תקינה',
  'signup.createAccount': 'צור חשבון',
  'signup.creating': 'יוצר...',
  'signup.terms': 'על ידי יצירת חשבון, אתה מסכים לתנאי השירות ולמדיניות הפרטיות.',
  'signup.success': 'הרישום הצליח! פרטי ההתחברות נשלחו לכתובת הדוא"ל שלך.',
  'signup.successTitle': 'הרישום הצליח!',
  'signup.successMessage': 'החשבון שלך נוצר בהצלחה.',
  'signup.emailSent': 'פרטי ההתחברות נשלחו לכתובת הדוא"ל שלך.',
  'signup.redirecting': 'מפנה לדף התחברות...',
  'signup.startupPackageLoaded': 'חבילת התחלה נטענה!',
  'signup.products': 'מוצרים',
  'signup.customers': 'לקוחות',
  'signup.users': 'משתמשים',
  'signup.demoDataReady': '✨ נתוני ההדגמה שלך מוכנים, תוכל להתחיל להשתמש בהם מיד!',
  'signup.loginInfo': '📧 פרטי ההתחברות שלך',
  'signup.loginInfoSent': '💡 מידע זה נשלח גם לכתובת הדוא"ל שלך',
  'signup.loginNow': 'התחבר עכשיו →',
};
